import type { ExportVersion } from '@/api/hooks/useAccountantExports';

const formatLabels: Record<string, string> = {
  csv: 'CSV transaction ledger',
  pdf: 'PDF Schedule C summary',
  xlsx: 'Excel workbook',
  qbo: 'Bank transactions for import · QuickBooks still categorizes',
  iif: 'QuickBooks Desktop import',
  zip: 'ZIP export package',
};

export function ExportFormatList({ version, grantId, taxYear, locked }: { version: ExportVersion; grantId: string; taxYear: number; locked: boolean }) {
  return (
    <section aria-labelledby="export-formats-heading" className="rounded-[10px] border border-border bg-card p-5">
      <h2 id="export-formats-heading" className="font-semibold">Formats</h2>
      <div className="mt-2 divide-y divide-border">
        {version.files.map((file) => (
          <div key={file.format} className="flex min-h-12 items-center justify-between gap-4 py-2 text-sm">
            <span>{formatLabels[file.format] ?? file.label}</span>
            <span className="flex items-center gap-3">
              <span className={file.status === 'failed' ? 'text-expense' : 'text-muted-foreground'}>{file.status === 'generating' ? 'Generating…' : file.status}</span>
              {file.status === 'done' && !locked && <a className="text-link underline" href={`/api/accountant/clients/${grantId}/years/${taxYear}/exports/${version.version}/files/${file.format}?download=true`}>Download</a>}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
